module.exports = __webpack_public_path__ + "static/screenshot-options-ed28ff33f55f6881c87e9612b94896f1.png";